export default "__VITE_ASSET__DCMOeevl__"